(() => {
  const site = document.querySelector('[data-bbx-site]');

  if (!site) return;

  const nav = site.querySelector('[data-bbx-nav]');
  const revealItems = Array.from(site.querySelectorAll('[data-bbx-reveal]'));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const showAll = () => {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  };

  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    showAll();
  } else {
    site.classList.add('bbx-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12,
      }
    );

    revealItems.forEach((item) => observer.observe(item));
  }

  const updateNav = () => {
    if (!nav) return;
    nav.classList.toggle('is-scrolled', window.scrollY > 20);
  };

  updateNav();
  window.addEventListener('scroll', updateNav, { passive: true });

  const menu = site.querySelector('[data-bbx-mobile-menu]');
  const menuToggle = site.querySelector('[data-bbx-menu-toggle]');
  const menuCloseButtons = menu
    ? Array.from(menu.querySelectorAll('[data-bbx-menu-close]'))
    : [];
  const menuLinks = menu
    ? Array.from(menu.querySelectorAll('.bbx-mobile-menu__links a, .bbx-mobile-menu__actions a'))
    : [];
  let menuWasOpened = false;

  const getMenuFocusables = () => {
    if (!menu) return [];

    return Array.from(
      menu.querySelectorAll(
        'a[href], button:not([disabled]):not([tabindex="-1"])'
      )
    ).filter((element) => !element.hidden);
  };

  const closeMenu = (restoreFocus = true) => {
    if (!menu || !menuToggle || menu.hidden) return;

    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    menuToggle.setAttribute('aria-label', 'Open navigation menu');
    document.documentElement.classList.remove('bbx-menu-open');

    window.setTimeout(() => {
      if (!menu.classList.contains('is-open')) {
        menu.hidden = true;
      }
    }, 220);

    if (restoreFocus) {
      menuToggle.focus();
    }
  };

  const openMenu = () => {
    if (!menu || !menuToggle || !menu.hidden) return;

    menu.hidden = false;
    menu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    menuToggle.setAttribute('aria-label', 'Close navigation menu');
    document.documentElement.classList.add('bbx-menu-open');
    menuWasOpened = true;

    window.requestAnimationFrame(() => {
      menu.classList.add('is-open');
      const focusables = getMenuFocusables();
      if (focusables.length) focusables[0].focus();
    });
  };

  if (menu && menuToggle) {
    menuToggle.addEventListener('click', () => {
      if (menu.hidden) {
        openMenu();
      } else {
        closeMenu();
      }
    });

    menuCloseButtons.forEach((button) => {
      button.addEventListener('click', () => closeMenu());
    });

    menuLinks.forEach((link) => {
      link.addEventListener('click', () => closeMenu(false));
    });

    document.addEventListener('keydown', (event) => {
      if (menu.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeMenu();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusables = getMenuFocusables();
      if (!focusables.length) return;

      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1080 && !menu.hidden) {
        closeMenu(false);
      }
    });

    window.addEventListener('pageshow', () => {
      if (menuWasOpened || !menu.hidden) {
        menu.classList.remove('is-open');
        menu.hidden = true;
        menu.setAttribute('aria-hidden', 'true');
        menuToggle.setAttribute('aria-expanded', 'false');
        menuToggle.setAttribute('aria-label', 'Open navigation menu');
        document.documentElement.classList.remove('bbx-menu-open');
      }
    });
  }
})();

(() => {
  const form = document.querySelector('[data-bbx-request-form]');

  if (!form || form.hasAttribute('data-bbx-calculator-form')) return;

  const submitButton = form.querySelector('[data-bbx-submit]');
  const submitLabel = form.querySelector('[data-bbx-submit-label]');
  const formStatus = form.querySelector('[data-bbx-form-status]');
  const requiredFields = Array.from(form.querySelectorAll('[required]'));
  const params = new URLSearchParams(window.location.search);
  const packageName = params.get('package');
  const requestType = params.get('request_type');
  const timingField = document.getElementById('timing');
  const itemField = document.getElementById('item');
  const notesField = document.getElementById('notes');

  const showFieldError = (field) => {
    const errorId = `${field.id}-error`;
    const error = document.getElementById(errorId);

    field.setAttribute('aria-invalid', 'true');

    if (error) {
      error.hidden = false;
    }
  };

  const clearFieldError = (field) => {
    const errorId = `${field.id}-error`;
    const error = document.getElementById(errorId);

    field.removeAttribute('aria-invalid');

    if (error) {
      error.hidden = true;
    }
  };

  requiredFields.forEach((field) => {
    field.addEventListener('invalid', () => showFieldError(field));
    field.addEventListener('input', () => {
      if (field.validity.valid) clearFieldError(field);
    });
    field.addEventListener('blur', () => {
      if (!field.validity.valid && field.value) showFieldError(field);
    });
  });

  if (requestType === 'Supply Drop' && timingField && itemField && notesField) {
    timingField.value = 'ASAP / Same-Day Preferred';

    let description = '';
    let notes = 'Supply Drop Request: ';

    switch (packageName) {
      case 'The Hustle Pack':
        description = 'The Hustle Pack requested. Includes 5 mixed-size boxes, 2 rolls of packing tape, 1 pack of protective filler, and 1 permanent marker.';
        notes += 'Starter pack for quick moves, small apartments, or last-minute pack-outs.';
        break;

      case 'Quick Box Bundle':
        description = 'Quick Box Bundle requested. Includes 8 mixed-size boxes for fast packing, moving, storage, or office use.';
        notes += 'Boxes only. Good fit for customers who need immediate box delivery.';
        break;

      case 'Tape and Wrap Pack':
        description = 'Tape + Wrap Pack requested. Includes 3 rolls of packing tape, 1 large roll of bubble wrap, and 1 pack of protective filler.';
        notes += 'Customer likely already has boxes and needs packing materials only.';
        break;

      case 'Emergency Supply Drop':
        description = 'Emergency Supply Drop requested. Custom supply mix needed based on urgency and job requirements.';
        notes += 'Urgent request. Same-day sourcing and fast turnaround may be required.';
        break;

      default:
        description = packageName;
        notes += packageName;
    }

    itemField.value = description;
    notesField.value = notes;
  }

  form.addEventListener('submit', (event) => {
    if (form.dataset.bbxSubmitting === 'true') {
      event.preventDefault();
      return;
    }

    if (!form.checkValidity()) return;

    form.dataset.bbxSubmitting = 'true';
    form.classList.add('is-submitting');
    form.setAttribute('aria-busy', 'true');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
    }

    if (submitLabel) {
      submitLabel.textContent = 'Submitting request';
    }

    if (formStatus) {
      formStatus.textContent = 'Your request is being submitted. Please keep this page open.';
      formStatus.hidden = false;
    }
  });

  window.addEventListener('pageshow', () => {
    form.dataset.bbxSubmitting = 'false';
    form.classList.remove('is-submitting');
    form.removeAttribute('aria-busy');

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
    }

    if (submitLabel) {
      submitLabel.textContent = 'Submit request';
    }

    if (formStatus) {
      formStatus.hidden = true;
      formStatus.textContent = '';
    }
  });
})();

(() => {
  const form = document.getElementById('BBXDriverInterest');

  if (!form) return;

  const submitButton = form.querySelector('[data-bbx-driver-submit]');
  const submitLabel = form.querySelector('[data-bbx-driver-submit-label]');

  const restoreForm = () => {
    form.dataset.bbxSubmitting = 'false';
    form.removeAttribute('aria-busy');

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-disabled');
    }

    if (submitLabel) {
      submitLabel.textContent = 'Join the Driver Network';
    }
  };

  form.addEventListener('submit', (event) => {
    if (form.dataset.bbxSubmitting === 'true') {
      event.preventDefault();
      return;
    }

    if (!form.checkValidity()) return;

    form.dataset.bbxSubmitting = 'true';
    form.setAttribute('aria-busy', 'true');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
    }

    if (submitLabel) {
      submitLabel.textContent = 'Submitting interest';
    }
  });

  window.addEventListener('pageshow', restoreForm);
})();
